import React from "react";
import { withRouter } from "react-router-dom";
import SegmentWrapper from "./SegmentWrapper";
import { getSingleJob } from "./SegmentWrapper";
import { trackViewJobsSearch } from "./tracking";
import { isBot } from "./botDetection";

const trackViewJob = () => {
  const match = window.location.href.match(/\/detail\/(.*)$/);
  const jobId = match ? match[1] : null;

  if (jobId) {
    getSingleJob(jobId)
      .then((singleJob) => {
        // Check if we have results and get the first job
        if (!singleJob || !Array.isArray(singleJob) || singleJob.length === 0) {
          console.warn("No job found for ID:", jobId);
          return;
        }

        singleJob = singleJob[0];

        // Add additional safety check for the job object
        if (!singleJob) {
          console.warn("Invalid job data for ID:", jobId);
          return;
        }

        let pro_only;
        let max_salary = "";
        let hourly_rate_range = "";

        if (singleJob.applicant_group === "PGA Professional Only") {
          pro_only = true;
        } else {
          pro_only = false;
        }

        if (singleJob.pay_schedule === "Salary") {
          if (
            singleJob.base_compensation_max &&
            singleJob.base_compensation_max.value
          ) {
            max_salary = singleJob.base_compensation_max.value;
          } else if (
            singleJob.base_compensation &&
            singleJob.base_compensation.value
          ) {
            max_salary = singleJob.base_compensation.value;
          }
        } else {
          if (
            singleJob.base_compensation &&
            singleJob.base_compensation.value
          ) {
            hourly_rate_range = singleJob.base_compensation.value;
          }
        }

        // Safely extract location info
        const location =
          singleJob.facilities && singleJob.facilities[0]
            ? `${singleJob.facilities[0].city || ""}, ${
                singleJob.facilities[0].state || ""
              }`
            : "";

        // Safely extract company info
        const company =
          singleJob.offices && singleJob.offices[0]
            ? singleJob.offices[0].name || ""
            : "";

        // Safely extract education info
        const education =
          singleJob.education && singleJob.education[0]
            ? singleJob.education[0]
            : false;

        window.analytics.track("View Job", {
          job_id: singleJob.jobId || "",
          job_location: location,
          job_post_date: singleJob.created
            ? new Date(singleJob.created * 1000).toISOString()
            : "",
          job_deadline: singleJob.submission_deadline
            ? new Date(singleJob.submission_deadline * 1000).toISOString()
            : "",
          job_position_type: singleJob.employment_type || "",
          job_minimum_experience: singleJob.years_experience || "",
          job_company: company,
          job_title: singleJob.jobTitle || "",
          job_additional_pga_education:
            singleJob.additional_pga_education || "",
          job_education_required: education,
          job_pga_pro_only: pro_only,
          job_max_salary: max_salary || 0,
          job_hourly_rate_range: hourly_rate_range || 0,
          page_url: window.location.href,
          page_path: window.location.pathname,
        });
      })
      .catch((error) => {
        console.error("Error tracking job view:", error);
      });
  }
};

const trackPageViews = () => {
  if (isBot()) {
    return;
  }

  if (
    window.location.href.includes("jobs") &&
    window.location.href.includes("pga") &&
    window.location.href.includes("/detail/")
  ) {
    trackViewJob();
  } else {
    window.analytics.page();
  }
};

class RouteChangeHandler extends React.Component {
  componentDidUpdate(prevProps) {
    if (sessionStorage.getItem("segment_userId")) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        trackPageViews();
      }
      trackViewJobsSearch();
    }
  }

  componentDidMount() {
    const MAX_RETRIES = 10;
    let retryCount = 0;
    let checkInterval = setInterval(() => {
      retryCount++;
      if (sessionStorage.getItem("segment_userId")) {
        clearInterval(checkInterval);
        trackPageViews();
        trackViewJobsSearch();
      } else if (retryCount >= MAX_RETRIES) {
        clearInterval(checkInterval);
        sessionStorage.setItem("segment_userId", "anonymous");
        trackPageViews();
        trackViewJobsSearch();
      }
    }, 500);
  }

  render() {
    return <SegmentWrapper />;
  }
}

export default withRouter(RouteChangeHandler);
